var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1665 4.5V5.74984C5.1665 6.53224 5.80077 7.1665 6.58317 7.1665C7.36557 7.1665 7.99984 6.53224 7.99984 5.74984V4.5H15.9998V5.74984C15.9998 6.53224 16.6341 7.1665 17.4165 7.1665C18.1989 7.1665 18.8332 6.53224 18.8332 5.74984V4.5H20.3333C21.2538 4.5 22 5.24619 22 6.16667V8.66667H2V6.16667C2 5.24619 2.74619 4.5 3.66667 4.5H5.1665Z",
    fill: "#B35F9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58333 2C6.81345 2 7 2.18655 7 2.41667V5.75C7 5.98012 6.81345 6.16667 6.58333 6.16667C6.35321 6.16667 6.16667 5.98012 6.16667 5.75V2.41667C6.16667 2.18655 6.35321 2 6.58333 2Z",
    fill: "#7CB141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 2C17.6468 2 17.8333 2.18655 17.8333 2.41667V5.75C17.8333 5.98012 17.6468 6.16667 17.4167 6.16667C17.1865 6.16667 17 5.98012 17 5.75V2.41667C17 2.18655 17.1865 2 17.4167 2Z",
    fill: "#7CB141"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.5H22V20.3333C22 21.2538 21.2538 22 20.3333 22H3.66667C2.74619 22 2 21.2538 2 20.3333V9.5ZM4.5 12C4.03976 12 3.66667 12.3731 3.66667 12.8333C3.66667 13.2936 4.03976 13.6667 4.5 13.6667H19.0833C19.5436 13.6667 19.9167 13.2936 19.9167 12.8333C19.9167 12.3731 19.5436 12 19.0833 12H4.5ZM4.5 15.3333C4.03976 15.3333 3.66667 15.7064 3.66667 16.1667C3.66667 16.6269 4.03976 17 4.5 17H12C12.4602 17 12.8333 16.6269 12.8333 16.1667C12.8333 15.7064 12.4602 15.3333 12 15.3333H4.5Z",
    fill: "#7CB141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.331e99503f2e14fd3c0e06efe28f17b4.svg";
export { ForwardRef as ReactComponent };